import React from 'react'

import { withStyles } from "@material-ui/core/styles";

import IconButton from '@material-ui/core/IconButton'
import Visibility from "@material-ui/icons/Visibility"
import Edit from "@material-ui/icons/Edit"
import Delete from "@material-ui/icons/Delete"
import Table from "components/Table/Table.js"
import Card from "components/Card/Card.js"
import CardHeader from "components/Card/CardHeader.js"
import CardBody from "components/Card/CardBody.js"
import Circular from "components/Circular/Circular"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from 'components/CustomButtons/Button.js'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem';
import CustomInput from "components/CustomInput/CustomInput.js"

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import GridItem from "components/Grid/GridItem.js"
import GridContainer from "components/Grid/GridContainer.js"

import { getAllLockersSelect } from "../../services/lockers/lockers";
import {
    getAllCondominios,
    saveCondominio,
    saveCondominioLockers,
    getCondominioLockers,
    deleteCondominioLockers,
    updateCondominio,
    deleteCondominio,
    getLockerRelated
} from "../../services/condominio/condominio";
import { createBrowserHistory } from "history";

class Usuarios extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: '',
            nome: '',
            address: '',

            lockers: [],

            load: true,
            loadSave: false,

            openModal: false,
            openModalDelete: false,
            deleteSelected: undefined,

            dataLockersGrid: [],
            dataLockersGridDelete: [],
            dataLockers: [],
            data: [],

            showSave: true,
            modoEdit: false,

            showValidation: false,

            availableLockers: [],

            currentUser: JSON.parse(localStorage.getItem("user")).data
        }

        this.onNovo = this.onNovo.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onEditar = this.onEditar.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onDeleteItemGridLockers = this.onDeleteItemGridLockers.bind(this)
        this.onBuscaDados = this.onBuscaDados.bind(this)
    }

    async componentDidMount() {

        if (this.props.lockerId !== undefined) {
            this.setState({ modoEdit: true })
        }

        this.onBuscaDados()
    }

    onBuscaDados = async () => {

        getAllLockersSelect((dataL) => {
            let availableLockers = [];

            // console.log("GET LOCKERS:", JSON.stringify(dataL))

            dataL.listLockers.forEach((locker, index) => {
                getLockerRelated(locker.value, (res) => {
                    if (res.length === 0) {
                        availableLockers.push(locker);
                    }
                })

                if (index === dataL.listLockers.length - 1) {
                    this.setState({
                        dataLockers: dataL.listLockers,
                        availableLockers
                    })

                    getAllCondominios((data) => {

                        if (data.length === 0) {
                            this.setState({ load: false })
                            return
                        }

                        const grid = data.map(item => {
                            return [
                                item.name,
                                item.address,
                                <>
                                    <IconButton aria-label="view" onClick={() => this.onEditar(item)}>
                                        <Edit className={this.props.classes.iconView} />
                                    </IconButton>
                                    <IconButton aria-label="view" onClick={() => this.setState({
                                        openModalDelete: true,
                                        deleteSelected: item
                                    })}>
                                        <Delete className={this.props.classes.iconView} />
                                    </IconButton>
                                    <IconButton aria-label="view" onClick={() => this.onShow(item)}>
                                        <Visibility className={this.props.classes.iconView} />
                                    </IconButton>
                                </>
                            ]
                        })

                        this.setState({
                            load: false,
                            data: grid,
                        })
                    })
                }
            })

        });

    }

    onNovo = () => {
        this.setState({
            id: '',
            nome: '',
            address: '',
            lockers: [],
            dataLockersGrid: [],
            openModal: true,
            showSave: true,
        })
    }

    onCancel = () => {
        this.setState({ openModal: false })
    }

    onDelete = () => {

        if (this.state.deleteSelected !== undefined) {
            deleteCondominio(this.state.deleteSelected.id, (data) => {

                this.setState({ loadSave: false, openModalDelete: false })
                this.onBuscaDados()
            })
        }
    }

    onEditar = async (item) => {

        getCondominioLockers(item.id, (data) => {
            let lockersCondominio = [];
            var dataSet = new Set();
            data.forEach(d => {
                dataSet.add(d);
            })

            if (data.length > 0) {
                lockersCondominio = this.state.dataLockers.filter(l => dataSet.has(l.value));
            }

            this.setState({
                id: item.id,
                nome: item.name,
                address: item.address,
                lockers: [],
                dataLockersGrid: lockersCondominio,
                openModal: true,
                showSave: true
            })
        });
    }

    onShow = async (item) => {

        getCondominioLockers(item.id, (data) => {
            let lockersCondominio = [];
            var dataSet = new Set();
            data.forEach(d => {
                dataSet.add(d);
            })

            if (data.length > 0) {
                lockersCondominio = this.state.dataLockers.filter(l => dataSet.has(l.value));
            }

            this.setState({
                id: item.id,
                nome: item.name,
                address: item.address,
                lockers: [],
                dataLockersGrid: lockersCondominio,
                openModal: true,
                showSave: false,
            })
        });
    }

    onSave = async () => {

        this.setState({ loadSave: true })
        let { dataLockersGrid } = this.state;

        if (this.state.id.length === 0) {
            saveCondominio({
                name: this.state.nome,
                address: this.state.address,
            }, (data) => {

                if (data) {

                    dataLockersGrid.forEach((locker, index) => {

                        saveCondominioLockers(
                            {
                                condominioId: data.id,
                                lockerId: locker.value
                            },
                            (dataR) => {
                                if (index == dataLockersGrid.length - 1) {
                                    this.setState({ loadSave: false, openModal: false, dataLockersGrid: [] })
                                    this.onBuscaDados()
                                }
                            }
                        )

                    });
                }

                this.setState({ loadSave: false, openModal: false })
                this.onBuscaDados()
            })
        }
        else {

            let { dataLockersGridDelete, dataLockersGrid } = this.state;

            updateCondominio(this.state.id,
                {
                    name: this.state.nome,
                    address: this.state.address
                }, (data) => {
                    this.setState({ loadSave: false, openModal: false })
                    this.onBuscaDados()
                }
            )

            dataLockersGrid.forEach((locker, index) => {

                saveCondominioLockers(
                    {
                        condominioId: this.state.id,
                        lockerId: locker.value
                    },
                    (data) => {
                        if (index == dataLockersGrid.length - 1) {
                            this.setState({ loadSave: false, openModal: false, dataLockersGrid: [] })
                            this.onBuscaDados()
                        }
                    }
                )

            });

            dataLockersGridDelete.forEach((locker, index) => {

                deleteCondominioLockers(
                    {
                        condominioId: this.state.id,
                        lockerId: locker
                    },
                    (data) => {
                        if (index == dataLockersGridDelete.length - 1) {
                            this.setState({ loadSave: false, openModal: false, dataLockersGridDelete: [] })
                            this.onBuscaDados()
                        }
                    }
                )

            });


            this.onBuscaDados();

        }
    }

    onDeleteItemGridLockers = (locker) => {

        let { dataLockersGridDelete } = this.state;

        dataLockersGridDelete.push(locker.value);

        const newGrid = this.state.dataLockersGrid.filter(item => item.value !== locker.value);
        this.setState({ dataLockersGrid: newGrid, dataLockersGridDelete })
    }

    render() {
        if (!localStorage.getItem("user")) {
            createBrowserHistory({ forceRefresh: true }).push("/");
        } else {
            createBrowserHistory({ forceRefresh: false }).push(`/`);
        }

        return (

            <GridContainer>

                {
                    !this.state.modoEdit ?
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={this.props.classes.cardTitleWhite}>Condomínio</h4>
                                <p className={this.props.classes.cardCategoryWhite}>Condomínios cadastrados</p>
                            </CardHeader>

                            <CardBody>
                                {
                                    this.state.load ? <Circular /> :
                                        <>
                                            <Button color="primary" onClick={this.onNovo}>Adicionar Novo</Button>
                                            <Table
                                                tableHeaderColor="primary"
                                                tableHead={["Nome", "Endereço", "Ação"]}
                                                tableData={this.state.data}
                                            />
                                        </>
                                }
                            </CardBody>
                        </Card> :
                        <>
                            {
                                this.state.load ? <Circular /> :
                                    <CardBody>
                                        <Table
                                            striped
                                            tableHeaderColor="primary"
                                            tableHead={["Nome", "Endereço", "Ação"]}
                                            tableData={this.state.data}
                                        />
                                    </CardBody>
                            }
                        </>
                }

                <Dialog
                    open={this.state.openModal}
                    onClose={() => { }}
                    aria-labelledby="responsive-dialog-title"
                    fullWidth={true}
                //maxWidth='lg'
                >
                    <DialogTitle id="responsive-dialog-title">{(this.state.showSave) ? ((this.state.id === '') ? 'Novo condomínio' : 'Editar condomínio') : ''}</DialogTitle>
                    <DialogContent>

                        <GridContainer>

                            <GridItem xs={12} sm={12} md={8}>
                                <CustomInput
                                    labelText="Nome"
                                    id="nome"
                                    value={this.state.nome}

                                    inputProps={{
                                        value: this.state.nome,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ nome: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="Endereço"
                                    id="address"
                                    value={this.state.address}

                                    inputProps={{
                                        value: this.state.address,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ address: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            {
                                !this.state.modoEdit ?
                                    <GridItem xs={12} sm={12} md={6}>
                                        <TextField
                                            id="standard-select-currency"
                                            select
                                            label="Lockers"
                                            fullWidth
                                            className={this.props.classes.inputMargin}
                                            value={this.state.lockers}
                                            onChange={e => {

                                                const item = this.state.dataLockers.filter(item => item.value === e.target.value)
                                                const existe = this.state.dataLockersGrid.filter(locker => locker.value === e.target.value)

                                                if (existe.length > 0) return

                                                this.setState({
                                                    dataLockersGrid: [...this.state.dataLockersGrid, ...item],
                                                    lockers: e.target.value
                                                })
                                            }}
                                        >
                                            {this.state.availableLockers.map((option, index) => (
                                                <MenuItem key={index} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </GridItem> : undefined
                            }

                        </GridContainer>

                        <div className={this.props.classes.divGrupos}>
                            {
                                !this.state.modoEdit ?
                                    <div className={this.props.classes.divItemGrupo}>
                                        <div className={this.props.classes.lockerVinculadoView}>
                                            <label>Lockers vinculados</label>
                                        </div>
                                        {
                                            this.state.dataLockersGrid.map((locker, index) => {

                                                return (
                                                    <div key={index} className={!this.state.showSave ? this.props.classes.noButtonDeleteLockerUser : undefined}>
                                                        {
                                                            this.state.showSave ?
                                                                <IconButton aria-label="view" onClick={() => this.onDeleteItemGridLockers(locker)}>
                                                                    <Delete className={this.props.classes.iconView} />
                                                                </IconButton> : undefined
                                                        }
                                                        <label>
                                                            {locker.label}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> : undefined
                            }

                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onCancel}>
                            Cancelar
                        </Button>
                        {
                            this.state.showSave ?
                                <Button onClick={this.onSave} color="primary">
                                    Salvar
                            </Button> : undefined
                        }
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalDelete}
                    onClose={() => this.setState({ openModalDelete: false, deleteSelected: undefined })}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">Deletar Condomínio</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Este processo de deletar um Condomínio não pode ser desfeito, deseja continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openModalDelete: false })} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={() => this.onDelete()} color="primary">
                            Deletar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.showValidation} autoHideDuration={6000} onClose={() => this.setState({ showValidation: false })}>
                    <MuiAlert onClose={() => this.setState({ showValidation: false })} elevation={6} variant="filled" severity='error'>
                        Você não tem permissão para realizar esta ação
                    </MuiAlert>
                </Snackbar>

            </GridContainer>
        )
    }
}

const styles = theme => ({
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    iconView: {
        color: "gray !important"
    },
    iconViewArrow: {
        color: "white !important",
    },
    buttonIcon: {
        padding: "5px"
    },
    dropdown: {
        right: "1.5%",
        top: "24%",
        position: "absolute"
    },
    removeMarginFromTop: {
        margin: 0
    },
    inputMargin: {
        marginTop: 10
    },

    lockerVinculadoView: {
        display: 'flex',
        flex: 1,
        background: '#f8f8f8',
        marginTop: 10,
        padding: 10,
        borderRadius: 2,
        borderBottomWidth: 1,
        borderBottomColor: '#ECECEC'
    },
    noButtonDeleteLockerUser: {
        padding: 5
    },
    divGrupos: {
        display: 'flex',
        flexDirection: 'row'
    },
    divItemGrupo: {
        width: '50%'
    }
});

export default withStyles(styles)(Usuarios);
